<template>
<div class="chapter">
<div class="inner_page">
<p class="copy" style="margin-top:2.5em;"><span class="sa">PUBLISHER:</span> Amy Marson</p>
<p class="copy"><span class="sa">CREATIVE DIRECTOR:</span> Gailen Runge</p>
<p class="copy"><span class="sa">PROJECT EDITOR:</span> Alice Mace Nakanishi</p>
<p class="copy"><span class="sa">DEVELOPMENTAL EDITORS:</span> Jenifer Dick, Edie McGinnis, Kimber Mitchell, and Deb Rowden</p>
<p class="copy"><span class="sa">TECHNICAL EDITORS:</span> Mary Atherton, Christina DeArmond, Kathe Dougherty, and Jane Miller</p>
<p class="copy"><span class="sa">COVER/BOOK DESIGNER:</span> April Mostek</p>
<p class="copy"><span class="sa">PRODUCTION COORDINATORS:</span> Joe Edge and Zinnia Heinzmann</p>
<p class="copy"><span class="sa">PRODUCTION ASSISTANT:</span> Jeanie German</p>
<p class="copy"><span class="sa">ILLUSTRATORS:</span> Lon Eric Craven and Eric Sears</p>
<p class="copy"><span class="sa">PHOTOGRAPHY BY</span> Aaron T. Leimkuehler and Natalie Turley</p>
<p class="copy1">Published by C&amp;T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?09985595